import React, { useEffect, useRef, useState } from "react";
import { renderGoogleButton } from "../auth/googleSignIn";

// Web Google sign-in button. Renders Google's OFFICIAL button (reliable
// popup-based ID-token flow) into a plain div — raw DOM elements are fine in
// the RN-Web/Next build (the whole src/web/* tree uses them). When Google
// isn't configured (no client id) we render nothing and report it up so the
// shell can hide the divider too.
//
// Native phones resolve GoogleButton.tsx instead (email-only fallback).

type Props = {
  onToken: (idToken: string) => void;
  // Called once we know whether Google is actually available here.
  onAvailability?: (available: boolean) => void;
};

export default function GoogleButton({ onToken, onAvailability }: Props) {
  const hostRef = useRef<HTMLDivElement | null>(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const el = hostRef.current;
      if (!el) return;
      // Match the form width (GIS clamps to 200–400).
      const width = el.offsetWidth || 360;
      const ok = await renderGoogleButton(el, onToken, width);
      if (cancelled) return;
      setReady(ok);
      onAvailability?.(ok);
    })();
    return () => {
      cancelled = true;
    };
    // onToken is stable per render of the screen; we only want to render the
    // GIS button once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        marginBottom: ready ? 18 : 0,
        minHeight: ready ? 44 : 0,
      }}
    >
      <div ref={hostRef} style={{ width: "100%", display: "flex", justifyContent: "center" }} />
    </div>
  );
}
